export default function Footer() {
  return (
    <footer className="py-5 bg-dark">
      <div className="container">
        <p className="m-0 text-center text-white">
          Copyright © Your Website 2022
        </p>
      </div>
    </footer>
  );
}
